import axios from 'axios';
import { store } from '@/store/store';
import { signOut } from '@/store/features/auth/auth-slice';

const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://dev-api.01maktab.uz';
// Ensure baseURL does NOT end with /api/v1 or trailing slash
const cleanBaseUrl = rawBaseUrl.replace(/\/api\/v1\/?$/, '').replace(/\/+$/, '');

const http = axios.create({
  baseURL: cleanBaseUrl,
});

http.interceptors.request.use(
  (config) => {
    // Prevent duplicate /api/v1/api/v1 in url
    if (config.url) {
      if (config.url.startsWith('/api/v1/api/v1/')) {
        config.url = config.url.replace('/api/v1/api/v1/', '/api/v1/');
      } else if (!config.url.startsWith('/api/v1') && !config.url.startsWith('http')) {
        config.url = `/api/v1${config.url.startsWith('/') ? config.url : `/${config.url}`}`;
      }
    }

    const token = store.getState().auth.userData?.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['Accept-Language'] = localStorage.getItem('locale') || 'uz';
    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    if (error?.response?.status === 401) {
      store.dispatch(signOut());
      window.location.reload();
    }

    throw error;
  }
);

export const httpV2 = http;

export default http;
